import state from './state';
import * as reducer from './reducer';

export default { state, reducer };
